/**
 * Defaults for artwork uploaders on Timbre.
 * You can import this object by itself, if you don't need to use it as a mixin.
 */
export const DEFAULT_ARTWORK_DROPZONE_CONFIG = Object.freeze({
  url: "/api/v1/artwork",
  params: {},
  acceptedFiles: "image/jpg,image/jpeg,image/pjpeg,image/png",
  title: "Upload New Artwork",
  dictDefaultMessage: "Drag and drop new Artwork here",
  uploadMultiple: true,
  parallelUploads: 20,
  maxFiles: 20,
  maxFilesize: 5, // 5MB
  timeout: 300000, // 5min
});

/**
 * Mixin import (default)
 */
export default {
  data: () => ({
    artwork_dropzone_config: {
      ...DEFAULT_ARTWORK_DROPZONE_CONFIG,
    },
  }),
};
